import React from "react";
import "../Css/Python.css";

import { PyFooter } from "./PyFooter";
import { useState, useEffect } from "react";
import { DotLoader } from "react-spinners";
import { Navbar } from "../Components/Nav";

const override = {
  display: "block",
  margin: "auto",
  borderColor: "red",
};

export const PyOperators = () => {
  const [loading, setLoading] = useState(false);
  let [color] = useState("#FF8C00");

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  return (
    <>
      <div className="App">
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              paddingTop: "210px",
            }}
          >
            <DotLoader
              color={color}
              loading={loading}
              cssOverride={override}
              size={100}
            />
          </div>
        ) : (
          <>
            <div className="container-fluid background_py">
              <div className="row">
                <Navbar />

                <div className="col-md-3"></div>
                <div className="col-md-6">
                  <div>
                    <img
                      className="logo"
                      src={process.env.PUBLIC_URL + "assets/images/pyLogo.png"}
                      width="60%"
                      alt="pylogo"
                      height="auto"
                    />
                  </div>
                </div>
                <div className="col-md-3"></div>
              </div>
            </div>
            <div
              className="container-fluid"
              style={{
                backgroundColor: "black",
                paddingTop: "60px",
              }}
            >
              <div className="row mt-2">
                <h1 className="py_h1">Python – Operators</h1>
                <hr style={{ color: "white" }}></hr>
                <div>
                  <p>
                    In Python, operators are symbols and used to perform a
                    specific operation on given values. Python has a rich
                    collection of operators, we will learn here.
                  </p>
                </div>
                <h1 className="py_h1">Types of Operators in Python</h1>
                <div className="col-md-4"></div>
                <div className="col-md-4">
                  <ul style={{ color: "white" }}>
                    <li>Arithmetic Operators</li>
                    <li>Assignment Operators</li>
                    <li>Relational Operators</li>
                    <li>Logical Operators</li>
                    <li>Bitwise Operators</li>
                    <li>Membership Operators</li>
                    <li>Identity Operators</li>
                  </ul>
                </div>
                <div className="col-md-4"></div>.
              </div>
              <div className="row mt-2">
                <h1 className="py_h1">
                  Arithmetic Operators (Mathematical Operators)
                </h1>
                <hr style={{ color: "white" }}></hr>
                <p>
                  Arithmetic or Mathematical operators in Python are used to
                  perform mathematical tasks.
                </p>
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#5d7b89",
                    fontFamily: "Fira Mono",
                  }}
                >
                  <div class="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th scope="col">S.No</th>
                          <th scope="col">Operators</th>
                          <th scope="col">Name</th>
                          <th scope="col">Example</th>
                          <th scope="col">Sample Output</th>
                        </tr>
                      </thead>
                      <tbody style={{ color: "white" }}>
                        <tr>
                          <th scope="row">1</th>
                          <td>+</td>
                          <td>Addition</td>
                          <td> x + y </td>
                          <td>10+20 = 30</td>
                        </tr>
                        <tr>
                          <th scope="row">2</th>
                          <td>-</td>
                          <td>Subtraction</td>
                          <td>x - y</td>
                          <td>30-10 = 20</td>
                        </tr>
                        <tr>
                          <th scope="row">3</th>
                          <td>*</td>
                          <td>Multiplication</td>
                          <td>x * y</td>
                          <td> 5 * 2 = 10</td>
                        </tr>
                        <tr>
                          <th scope="row">4</th>
                          <td>/</td>
                          <td>Division</td>
                          <td>x / y</td>
                          <td> 12 / 3 = 4</td>
                        </tr>
                        <tr>
                          <th scope="row">5</th>
                          <td>%</td>
                          <td>Modulus</td>
                          <td>x % y</td>
                          <td> 5 % 2 = 1</td>
                        </tr>
                        <tr>
                          <th scope="row">6</th>
                          <td>**</td>
                          <td>Exponentiation</td>
                          <td>x ** y</td>
                          <td> 2 ** 3 = 8</td>
                        </tr>
                        <tr>
                          <th scope="row">7</th>
                          <td>{"//"}</td>
                          <td>Floor division</td>
                          <td>x // y</td>
                          <td> 15 ** 2 = 7</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="row mt-4">
                <h1 className="py_h1">Python Assignment Operators</h1>
                <hr style={{ color: "white" }}></hr>
                <p>
                  Assignment operators are used to assign values to variables:
                </p>
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#5d7b89",
                    fontFamily: "Fira Mono",
                  }}
                >
                  <div class="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th scope="col">S.No</th>
                          <th scope="col">Operators</th>
                          <th scope="col">Example</th>
                          <th scope="col">Same As</th>
                          <th scope="col">Command</th>
                          <th scope="col">Sample Output</th>
                        </tr>
                      </thead>
                      <tbody style={{ color: "white" }}>
                        <tr>
                          <th scope="row">1</th>
                          <td>=</td>
                          <td>x = 5</td>
                          <td> x = 5</td>
                          <td>
                            <span className="python-function">print</span>(x)
                          </td>
                          <td>5</td>
                        </tr>
                        <tr>
                          <th scope="row">2</th>
                          <td>+=</td>
                          <td>x += 3</td>
                          <td> x = x + 3</td>
                          <td>
                            <span className="python-function">print</span>(x)
                          </td>
                          <td>8</td>
                        </tr>
                        <tr>
                          <th scope="row">3</th>
                          <td>-=</td>
                          <td>x -= 3</td>
                          <td>x = x - 3</td>
                          <td>
                            <span className="python-function">print</span>(x)
                          </td>
                          <td>2</td>
                        </tr>
                        <tr>
                          <th scope="row">4</th>
                          <td>*=</td>
                          <td>x *= 3</td>
                          <td>x = x * 3</td>
                          <td>
                            <span className="python-function">print</span>(x)
                          </td>
                          <td>15</td>
                        </tr>
                        <tr>
                          <th scope="row">5</th>
                          <td>/=</td>
                          <td>x /= 3</td>
                          <td>x = x / 3</td>
                          <td>
                            <span className="python-function">print</span>(x)
                          </td>
                          <td>1.6666666666666667</td>
                        </tr>
                        <tr>
                          <th scope="row">6</th>
                          <td>%=</td>
                          <td>x %= 3</td>
                          <td>x = x % 3</td>
                          <td>
                            <span className="python-function">print</span>(x)
                          </td>
                          <td>2</td>
                        </tr>
                        <tr>
                          <th scope="row">7</th>
                          <td>{"//="}</td>
                          <td>x //= 3</td>
                          <td>x = x // 3</td>
                          <td>
                            <span className="python-function">print</span>(x)
                          </td>
                          <td>1</td>
                        </tr>
                        <tr>
                          <th scope="row">8</th>
                          <td>**=</td>
                          <td>x **= 3</td>
                          <td>x = x ** 3</td>
                          <td>
                            <span className="python-function">print</span>(x)
                          </td>
                          <td>125</td>
                        </tr>
                        <tr>
                          <th scope="row">9</th>
                          <td>&=</td>
                          <td>x &= 3</td>
                          <td>x = x & 3</td>
                          <td>
                            <span className="python-function">print</span>(x)
                          </td>
                          <td>1</td>
                        </tr>
                        <tr>
                          <th scope="row">10</th>
                          <td>|=</td>
                          <td>x |= 3</td>
                          <td>x = x | 3</td>
                          <td>
                            <span className="python-function">print</span>(x)
                          </td>
                          <td>7</td>
                        </tr>
                        <tr>
                          <th scope="row">11</th>
                          <td>^=</td>
                          <td>x ^= 3</td>
                          <td>x = x ^ 3</td>
                          <td>
                            <span className="python-function">print</span>(x)
                          </td>
                          <td>6</td>
                        </tr>
                        <tr>
                          <th scope="row">12</th>
                          <td>{">>="}</td>
                          <td>{"x >>= 3"}</td>
                          <td>{"x = x >> 3"}</td>
                          <td>
                            <span className="python-function">print</span>(x)
                          </td>
                          <td>0</td>
                        </tr>
                        <tr>
                          <th scope="row">13</th>
                          <td> {"<<="}</td>
                          <td>{"x<<= 3"}</td>
                          <td>{"x = x << 3"}</td>
                          <td>
                            <span className="python-function">print</span>(x)
                          </td>
                          <td>40</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">Python Comparison Operators</h1>
                <hr style={{ color: "white" }} />
                <div>
                  <p>Comparison operators are used to compare two values:</p>
                </div>
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#5d7b89",
                    fontFamily: "Fira Mono",
                  }}
                >
                  <div class="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th scope="col">S.No</th>
                          <th scope="col">Operators</th>
                          <th scope="col">Example</th>
                          <th scope="col">Same As</th>

                          <th scope="col">Sample Output</th>
                        </tr>
                      </thead>
                      <tbody style={{ color: "white" }}>
                        <tr>
                          <th scope="row">1</th>
                          <td>==</td>
                          <td>Equal</td>
                          <td>2 == 3 </td>
                          <td>False</td>
                        </tr>
                        <tr>
                          <th scope="row">2</th>
                          <td>!=</td>
                          <td>Not equal</td>
                          <td>2 != 3</td>
                          <td>True</td>
                        </tr>
                        <tr>
                          <th scope="row">3</th>
                          <td>{">"}</td>
                          <td>Greater than</td>
                          <td>{"5 > 3"}</td>
                          <td>True</td>
                        </tr>
                        <tr>
                          <th scope="row">3</th>
                          <td>{"<"}</td>
                          <td>Less than</td>
                          <td>{"5 < 3"}</td>
                          <td>False</td>
                        </tr>
                        <tr>
                          <th scope="row">3</th>
                          <td>{">="}</td>
                          <td>Greater than or equal to</td>
                          <td>{"5 >= 3"}</td>
                          <td>True</td>
                        </tr>
                        <tr>
                          <th scope="row">3</th>
                          <td>{"<="}</td>
                          <td>Less than or equal to</td>
                          <td>{"5 <= 3"}</td>
                          <td>False</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">Python Logical Operators</h1>
                <hr style={{ color: "white" }} />
                <p>
                  Logical operators are used to combine conditional statements:
                </p>
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#5d7b89",
                    fontFamily: "Fira Mono",
                  }}
                >
                  <div class="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th scope="col">S.No</th>
                          <th scope="col">Operators</th>
                          <th scope="col">Description</th>
                          <th scope="col">Example</th>
                          <th scope="col"> Sample Output</th>
                        </tr>
                      </thead>
                      <tbody style={{ color: "white" }}>
                        <tr>
                          <th scope="row">1</th>
                          <td>and</td>
                          <td>Returns True if both statements are true</td>
                          <td> {"x < 5 and  x < 10 "}</td>
                          <td> True</td>
                        </tr>
                        <tr>
                          <th scope="row">2</th>
                          <td>or</td>
                          <td>Returns True if one of the statements is true</td>
                          <td> {"x < 5 or x < 4 "}</td>
                          <td> True</td>
                        </tr>
                        <tr>
                          <th scope="row">3</th>
                          <td>not</td>
                          <td>
                            Reverse the result, returns False if the result is
                            true
                          </td>
                          <td> {"not(x < 5 and x < 10)"}</td>
                          <td>False</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">Python Identity Operators</h1>
                <hr style={{ color: "white" }} />
                <p>
                  {" "}
                  Identity operators are used to compare the objects, not if
                  they are equal, but if they are actually the same object, with
                  the same memory location:
                </p>

                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#5d7b89",
                    fontFamily: "Fira Mono",
                  }}
                >
                  <div class="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th scope="col">S.No</th>
                          <th scope="col">Operator</th>
                          <th scope="col">Description</th>
                          <th scope="col">Example</th>
                          <th scope="col">Command</th>
                          <th scope="col"> Sample Output</th>
                        </tr>
                      </thead>
                      <tbody style={{ color: "white" }}>
                        <tr>
                          <th scope="row">1</th>
                          <td>is</td>
                          <td>
                            Returns True if both variables are the same object
                          </td>
                          <td>
                            <p>
                              x = ["apple", "banana"] , y = ["apple", "banana"]
                            </p>
                          </td>
                          <td>
                            <p>
                              <span className="python-function">print</span> (x
                              is z)
                            </p>
                            <p>
                              <span className="python-function">print</span>(x
                              is y)
                            </p>
                            <p>
                              <span className="python-function">print</span>(x
                              == y)
                            </p>
                          </td>
                          <td>
                            <p>True</p>
                            <p>False</p>
                            <p>True</p>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">2</th>
                          <td>is not</td>
                          <td>
                            Returns True if both variables are not the same
                            object
                          </td>
                          <td>
                            <p>
                              x = ["apple", "banana"] , y = ["apple", "banana"]
                            </p>
                          </td>
                          <td>
                            <p>
                              <span className="python-function">print</span> (x
                              is not z)
                            </p>
                            <p>
                              <span className="python-function">print</span>(x
                              is not y)
                            </p>
                            <p>
                              <span className="python-function">print</span>(x
                              != y)
                            </p>
                          </td>
                          <td>
                            <p>False</p>
                            <p>True</p>
                            <p>False</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">Python Membership Operators</h1>
                <hr style={{ color: "white" }} />
                <p>
                  Membership operators are used to test if a sequence is
                  presented in an object:
                </p>

                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#5d7b89",
                    fontFamily: "Fira Mono",
                  }}
                >
                  <div class="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th scope="col">S.No</th>
                          <th scope="col">Operator</th>
                          <th scope="col">Description</th>
                          <th scope="col">Example</th>
                          <th scope="col">Command</th>
                          <th scope="col"> Sample Output</th>
                        </tr>
                      </thead>
                      <tbody style={{ color: "white" }}>
                        <tr>
                          <th scope="row">1</th>
                          <td>in</td>
                          <td>
                            Returns True if a sequence with the specified value
                            is present in the object
                          </td>
                          <td>x = ["apple", "banana"]</td>
                          <td>print("banana" in x)</td>
                          <td>True</td>
                        </tr>
                        <tr>
                          <th scope="row">2</th>
                          <td> not in</td>
                          <td>
                            Returns True if a sequence with the specified value
                            is not present in the object
                          </td>
                          <td>x = ["apple", "banana"]</td>
                          <td>print("pineapple" not in x)</td>
                          <td>True</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">Python Bitwise Operators</h1>
                <hr style={{ color: "white" }} />
                <p> Bitwise operators are used to compare (binary) numbers:</p>

                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#5d7b89",
                    fontFamily: "Fira Mono",
                  }}
                >
                  <div class="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th scope="col">S.No</th>
                          <th scope="col">Operator</th>
                          <th scope="col">Name</th>
                          <th scope="col">Description</th>
                        </tr>
                      </thead>
                      <tbody style={{ color: "white" }}>
                        <tr>
                          <th scope="row">1</th>
                          <td>&</td>
                          <td>AND</td>

                          <td> Sets each bit to 1 if both bits are 1</td>
                        </tr>
                        <tr>
                          <th scope="row">2</th>
                          <td>|</td>
                          <td>OR</td>
                          <td>Sets each bit to 1 if one of two bits is 1</td>
                        </tr>
                        <tr>
                          <th scope="row">3</th>
                          <td>^</td>
                          <td>XOR</td>
                          <td>
                            Sets each bit to 1 if only one of two bits is 1{" "}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">4</th>
                          <td>~</td>
                          <td>NOT</td>
                          <td>Inverts all the bits</td>
                        </tr>
                        <tr>
                          <th scope="row">5</th>
                          <td>{"<<"}</td>
                          <td>Zero fill left shift</td>
                          <td>
                            Shift left by pushing zeros in from the right and
                            let the leftmost bits fall off
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">6</th>
                          <td>{">>"}</td>
                          <td>Signed right shift</td>
                          <td>
                            Shift right by pushing copies of the leftmost bit in
                            from the left, and let the rightmost bits fall off
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <PyFooter />
          </>
        )}
      </div>
    </>
  );
};
